import { VyStack } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import {
  DiscountSection,
  PaymentSection,
  PricingSection,
  ScheduleSection,
  UpgradeOptionsSection,
} from '../sections';

export function OneTimeVariant() {
  const { isInvoice } = useChargeContext();
  return (
    <VyStack sx={{ gap: 2.5 }}>
      <PricingSection showAsCredit />
      <DiscountSection />
      {!isInvoice && <ScheduleSection showOneTimeDateRange />}
      {!isInvoice && <PaymentSection showPaymentTerm={false} />}
      <UpgradeOptionsSection />
    </VyStack>
  );
}
